module.exports = __webpack_public_path__ + "img/logo-genuine-leather.681a537d.svg";